import { POCFieldAttribute, POCFieldAttributeAPI } from './poc-fields.type';

export const mapPOCFieldAttributeFromApiToModel = (field: POCFieldAttributeAPI): POCFieldAttribute => ({
    attribute: field.attribute,
    mandatory: field.mandatory,
});
